import React from 'react';
import css from './SignupForm.module.css';
import { FieldPhoneNumberInput, FieldTextInput } from '../../../components';
import { composeValidators, required } from '../../../util/validators';
import classNames from 'classnames';
import { PHONE } from '../../../util/constants';
import { FormFieldName } from '../../../util/enums';

const BrandFormFields = ({
  intl,
  formId,
  emailRequired,
  emailFormatValid,
  isEditListingDetailsForm,
  handleBioChange,
  remainingChars,
  bio,
}) => {
  const { formatMessage: f } = intl;

  // Validator to ensure the phone number contains only digits.
  const numericValidator = value =>
    value && !/^\d+$/.test(value)
      ? f({
          id: 'BrandFormFields.phoneNumberNumericError',
          defaultMessage: 'Phone number must contain only digits.',
        })
      : undefined;

  const field = (name, type = 'text', props = {}) => {
    const id = formId ? `${formId}.${name}` : name;
    const msgId = `BrandFormFields.${name}`;
    const isPhone = type === PHONE;
    const Component = isPhone ? FieldPhoneNumberInput : FieldTextInput;

    let validateFn;
    if (name === FormFieldName.EMAIL) {
      validateFn = composeValidators(emailRequired, emailFormatValid);
    } else if (name === FormFieldName.PHONE_NUMBER) {
      validateFn = composeValidators(required(f({ id: `${msgId}Required` })), numericValidator);
    } else {
      validateFn = required(f({ id: `${msgId}Required` }));
    }
    const getAutoComplete = name => {
      if (name === FormFieldName.EMAIL) return 'email';
      if (name === FormFieldName.FIRST_NAME) return 'given-name';
      if (name === FormFieldName.LAST_NAME) return 'family-name';
      return undefined;
    };

    // Prepare additional props for description field
    const descriptionProps =
      name === FormFieldName.DESCRIPTION
        ? {
            value: bio,
            onChange: handleBioChange,
          }
        : {};

    const rawLabel = f({ id: `${msgId}Label` });
    const label =
      rawLabel === 'Description'
        ? f({ id: 'CustomLabel.companyDescription', defaultMessage: 'Company Description' })
        : rawLabel;

    return (
      <Component
        className={css.formFld}
        type={isPhone ? 'text' : type}
        id={id}
        name={name}
        autoComplete={getAutoComplete(name)}
        label={label}
        placeholder={f({ id: `${msgId}Placeholder` })}
        validate={validateFn}
        disabled={name === FormFieldName.EMAIL && isEditListingDetailsForm}
        {...descriptionProps}
        {...props}
      />
    );
  };

  return (
    <>
      <div className={css.formRow}>
        {field('organizationName')}
        {field('email')}
      </div>
      <div className={css.formRow}>
        {field('firstName')}
        {field('lastName')}
      </div>
      <div className={css.formRow}>{field('contactJobTitle')}</div>
      <div className={classNames(css.formRow, css.fullWidth)}>{field('phoneNumber', 'phone')}</div>
      <div className={classNames(css.formRow, css.fullWidth)}>
        {field('description', 'textarea', { className: css.description })}
        <div
          className={classNames(css.characterCount, {
            [css.warning]: remainingChars < 10 && remainingChars > 0,
            [css.limitReached]: remainingChars === 0,
          })}
        >
          {remainingChars}{' '}
          {intl.formatMessage({
            id: 'SignupForm.descriptionCharactersLeft',
          })}
        </div>
      </div>
    </>
  );
};

export default BrandFormFields;
